<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-luckynangkwak">
      <div class="px-3 col-3 p-0">
        <div class="heading-luckynangkwak">{{ $t("result.round") }}</div>
        <div class="text-subhead-luckynangkwak">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-luckynangkwak">
          {{ $t("result.bet") + `${currency}` }}
        </div>
        <div class="text-subhead-luckynangkwak">
          {{ data.count === 0
            ? data.bet
            : data.detail.summary[data.count].bet.amount | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-luckynangkwak">
          {{ $t("result.winlose") + `${currency}` }}
        </div>
        <div class="text-subhead-luckynangkwak">
          {{ winlose | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-luckynangkwak">
          {{ $t("result.balance") + `${currency}` }}
        </div>
        <div class="text-subhead-luckynangkwak">
          {{ balance | currencyFormatter }}
        </div>
      </div>
    </div>
    <div class="content-result-luckynangkwak pt-3">
      <div class="text-games-luckynangkwak">{{ "Lucky Nangkwak" }}</div>
      <div class="text-subgame-luckynangkwak">{{ $t("luckynangkwak.name") }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>

      <div class="d-flex flex-row justify-content-center" style="margin-top: 40px;">
        <img v-if="winnings.length > 0" class="d-flex col-8 mb-4"
          :src="require(`../../assets/resultGame/luckynangkwak/win.png`)" alt="" />
        <img v-else class="d-flex col-8 mb-4 lose" :src="require(`../../assets/resultGame/luckynangkwak/lose.png`)"
          alt="" />
      </div>
      <div class="col-12 justify-content-center d-flex flex-row p-0">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white">
          <i v-if="isFreespin || isRespin" class="fas fa-caret-left arrow-side-luckynangkwak" @click="delCount()"></i>
        </div>

        <!-- <div class="d-flex col-10 table-luckynangkwak container" /> -->

        <div class="d-flex flex-column">
          <div class="top-reel justify-content-center">
            <div class="" v-for="(row, index) in reels[6]" :key="index">
              <div style="position: relative; text-align: center;">
                <img class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/1/symbol_${row}.png`)
                  " alt="" />
                <div v-if="reels[6][index] === 10" class="multiplier-text ">
                  x{{ multiplierReel[6][index] }}
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-row slot-container">
            <div class="d-flex flex-column">
              <div v-for="(reel, index) in this.newReel[0]" :key="index">
                <div style="position: relative; text-align: center;">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-luckynangkwak"
                    :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]}/symbol_${reel[0]}.png`)" alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/luckynangkwak/silver${reel[1]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/luckynangkwak/gold${reel[1]}.png`)
                    " alt="" />
                  <div v-if="reels[0][index] === 10" class="multiplier-text ">
                    x{{ multiplierReel[0][index] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[1]" :key="index">
                <div style="position: relative; text-align: center;">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`"
                    :src="require(`../../assets/resultGame/luckynangkwak/silver${reel[1]}.png`)" alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`"
                    :src="require(`../../assets/resultGame/luckynangkwak/gold${reel[1]}.png`)" alt="" />
                  <!-- <div style="color:white">{{data.detail.reels[1]}}</div> -->
                  <div v-if="reels[1][index] === 10" class="multiplier-text ">
                    x{{ multiplierReel[1][index] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[2]" :key="index">
                <div style="position: relative; text-align: center;">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-luckynangkwak"
                    :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]}/symbol_${reel[0]}.png`)
                      " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/luckynangkwak/silver${reel[1]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/luckynangkwak/gold${reel[1]}.png`)
                    " alt="" />
                  <div v-if="reels[2][index] === 10" class="multiplier-text ">
                    x{{ multiplierReel[2][index] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[3]" :key="index">
                <div style="position: relative; text-align: center;">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/luckynangkwak/silver${reel[1]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/luckynangkwak/gold${reel[1]}.png`)
                    " alt="" />
                  <div v-if="reels[3][index] === 10" class="multiplier-text ">
                    x{{ multiplierReel[3][index] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[4]" :key="index">
                <div style="position: relative; text-align: center;">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/luckynangkwak/silver${reel[1]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/luckynangkwak/gold${reel[1]}.png`)
                    " alt="" />
                  <div v-if="reels[4][index] === 10" class="multiplier-text ">
                    x{{ multiplierReel[4][index] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[5]" :key="index">
                <div style="position: relative; text-align: center;">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-luckynangkwak" :src="require(`../../assets/resultGame/luckynangkwak/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/luckynangkwak/gold${reel[1]}.png`)
                    " alt="" />
                  <div v-if="reels[5][index] === 10" class="multiplier-text ">
                    x{{ multiplierReel[5][index] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!isEndRound" class="fas fa-caret-right arrow-side-luckynangkwak" @click="addCount()"></i>
        </div>
      </div>

      <div class="text-center py-4 text-games-luckynangkwak">
        <h1 v-if="isFreespin">{{ $t("result.freespin") }} {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
        <h1 v-else>{{ $t("main-game.spin") }} {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
      </div>
      <div v-if="winnings.length > 0 || data.detail.win > 0" class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3" />
        <div class="text-detail align-items-center d-flex px-3">
          {{ $t("result.detail") }}
        </div>
        <hr class="line col-3" />
      </div>
      <div v-if="data.detail.featureBuy" class="text-subgame-luckynangkwak">
        {{ $t("featurebuy.title") }}
      </div>
      <br />
      <div class="col-12 justify-content-center d-flex flex-row">
        <div v-if="winlose > 0" class="col-12 multiplier-box-luckynangkwak align-items-center">
          <h1 class="my-1 green">
            {{ $t("luckynangkwak.stack-multiplier") }} x{{ this.multiplier }}
          </h1>
          <h1 class="my-1 green"> {{ $t("luckynangkwak.totalwin") }}
            {{ ((winlose / this.multiplier)) | currencyFormatter }}
            x {{ this.multiplier }}
            = {{ (winlose) | currencyFormatter }}
          </h1>
        </div>
        <div v-else-if="winnings.length > 0" class="col-12 multiplier-box-luckynangkwak align-items-center">
          <h1 class="my-1 green">
            {{ $t("luckynangkwak.multiplier-title") }} x{{ round }}
          </h1>
        </div>
      </div>
      <div v-if="winnings.length" class="col-12 justify-content-start d-flex flex-row">
        <div class=" p-2 px-3 
                      justify-content-start align-items-center container">
          <div class="bet-wrapper justify-content-between item d-flex flex-row col-12"
            v-for="(detail, index) in winnings" :key="index">
            <div class="d-flex flex-row">
              <img class="icon-detail-luckynangkwak"
                :src="require(`../../assets/resultGame/luckynangkwak/1/symbol_${detail.symbol}.png`)" alt="" />
              <div style="margin-left:10px" class=" d-flex text-win align-items-center 
                            justify-content-center">
                <p class="my-1 green">{{ ` ${detail.row} ` + $t("result.kind") }}</p>
              </div>
            </div>
            <div class="d-flex text-win justify-content-center align-items-center px-3">
              <p class="my-1 green"> {{ currency }} {{ detail.amount | currencyFormatter }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-luckynangkwak",
  props: {
    data: Object,
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      date: "",
      time: "",
      currency: this.data.currency ? this.data.currency : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      multiplierReel: this.data.detail.multiplierReels ? this.data.detail.multiplierReels : null,
      isFreespin: false,
      multiplier: 0,
      reels: [],
      reelSizes: [],
      newReel: [],
      winlose: 0,
      balance: 0,
      winnings: [],
      pages: 0,
      round: 0,
    };
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight =
        document.getElementsByClassName("header-luckynangkwak")[0].offsetHeight;
    },
    async mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.isFreespin =
        result.state === "FREESPIN" ||
        result.state === "FREERESPIN";
      this.isRespin = result.state === "RESPIN";
      this.state = result.state;
      this.nextState = result.nextState;
      this.reels = result.reels;
      this.reelSizes = result.reelSizes;
      this.multiplier = result.multiplier;
      this.multiplierReel = result.multiplierReels;
      this.isEndRound = result.isEndRound;

      this.newReel = await this.mapTable(this.reels, this.reelSizes);

      if (result.isCoin) this.currency = 'AMS';
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      this.winnings = result.winnings;
      this.round = result.spinRound;
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }

    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async mapTable(reel, reelSize) {
      let newMap = [];
      let newReel = [];
      for (let i = 0; i < reel.length; i++) {
        newReel = [];
        for (let j = 0; j < reel[i].length; j++) {
          let symbolMap = [reel[i][j], reelSize[i][j]];
          newReel.push(symbolMap);
        }
        newMap.push(newReel);
      }
      return newMap;
    },
  },
};
</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933;
  /* margin: 0; */
}

img {
  pointer-events: none;
  cursor: default;
}

.lose {
  visibility: hidden;
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.fg-image {
  width: 570px;
}

.text-win {
  height: 90px;
}

.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-luckynangkwak {
  width: 100px;
  height: 80px;
  padding: 4px;
}

.icon-bonus-luckynangkwak {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-luckynangkwak {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-luckynangkwak {
  /* background: #0c161f; */
  border-radius: 10px;
  /* min-height: 200px; */
  /* max-height: 300px; */
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.multiplier-box-luckynangkwak {
  /* background: #0c161f; */
  border-radius: 10px;
  min-height: 50px;
  max-height: 100px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.bonus-box-luckynangkwak {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-luckynangkwak .item {
  color: #fff;
  /* background: #06112d; */
  line-height: 1;
  border-radius: 10px;
  /* border: 1.5px solid #cac095; */
}

.bet-box-luckynangkwak .bet-wrapper-luckynangkwak:not(:first-child) .item {
  margin-top: 10px;
  width: 800px;
}

.bet-wrapper-luckynangkwak,
.result-wrapper {
  font-size: 35px;
  width: 800px;
}

.header-luckynangkwak {
  background: #B39D86;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-luckynangkwak>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-luckynangkwak {
  color: #000000;
  text-align: center;
}

.content-result-luckynangkwak {
  background: #271A1A;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-luckynangkwak {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-luckynangkwak {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-luckynangkwak {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-subgame-luckynangkwak {
  font-size: 20px;
  color: #ffd500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.icon-symbol-luckynangkwak {
  width: 100%;
  /* padding: 5%; */
}

.bet-box-luckynangkwak {
  min-width: 600px;
  max-width: auto;
}

.win-box {
  width: 760px;
}

.icon-symbol {
  position: absolute;
  transform: translate(-124px, -5px);
}

.icon-symbol.-level1 {
  width: 123px;
  height: 116px;
}

.icon-symbol.-level2 {
  width: 122px;
  height: 221px;
}

.icon-symbol.-level3 {
  width: 122px;
  height: 328px;
}

.icon-symbol.-level4 {
  width: 124px;
  height: 434px;
}

.table-luckynangkwak {
  background: url("~@/assets/resultGame/luckynangkwak/slotmachine.png") no-repeat;
  z-index: 5;
  background-size: 764px 645px;
  /* set Bg Table HERE */
  width: 764px;
  height: 645px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  margin-top: 48px;
  position: absolute;
  z-index: 0;
  transform: translate(0px, -56px);
}

.slot-container {
  position: relative;
}

.top-reel {
  display: flex;
  flex-direction: row;
  position: relative;
}

.table-pos {
  transform: translate(0px, -7px);
}

.text-multiplier {
  width: 689px;
  text-align: center;
}

@media screen and (max-width: 1030px) {
  .table-luckynangkwak {
    background-size: 760px 640px;
    width: 760px;
    height: 640px;
    transform: translate(0px, -55px);
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-luckynangkwak {
    min-width: 580px;
    max-width: auto;
    /* height: 280px; */
  }

  .bet-wrapper-luckynangkwak {
    width: 800px
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-125px, -6px);
  }

  .icon-symbol.-level1 {
    width: 124px;
    height: 117px;
  }

  .icon-symbol.-level2 {
    width: 124px;
    height: 222px;
  }

  .icon-symbol.-level3 {
    width: 124px;
    height: 327px;
  }

  .icon-symbol.-level4 {
    width: 127px;
    height: 431px;
  }
}

@media screen and (min-width: 1060px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -115px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-luckynangkwak,
  .result-wrapper {
    font-size: 33px;
    width: 800px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-125px, -7px);
  }

  .icon-symbol.-level1 {
    width: 123px;
    height: 117px;
  }

  .icon-symbol.-level2 {
    width: 123px;
    height: 223px;
  }

  .icon-symbol.-level3 {
    width: 123px;
    height: 327px;
  }

  .icon-symbol.-level4 {
    width: 126px;
    height: 433px;
  }
}

.line {
  background-color: #fff;
  height: 2px;
  width: 100%;
  font-size: 28px;
}

.red {
  color: #ff0000;
}

.green {
  color: #fff;
  font-size: 28px;
}

.win-box {
  width: 689px;
}

@media screen and (max-width: 900px) {
  .table-luckynangkwak {
    background-size: 747px 645px;
    width: 747px;
    height: 645px;
    transform: translate(0px, -58px);
  }

  .top-reel {
    width: 67%;
    transform: translate(124px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-125px, -6px);
  }

  .icon-symbol.-level1 {
    width: 124px;
    height: 117px;
  }

  .icon-symbol.-level2 {
    width: 124px;
    height: 222px;
  }

  .icon-symbol.-level3 {
    width: 124px;
    height: 327px;
  }

  .icon-symbol.-level4 {
    width: 124px;
    height: 432px;
  }
}

@media screen and (max-width: 870px) {
  .table-luckynangkwak {
    background-size: 729px 628px;
    width: 729px;
    height: 628px;
    transform: translate(-2px, -59px);
  }

  .top-reel {
    width: 67%;
    transform: translate(120px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-121px, -6px);
  }

  .icon-symbol.-level1 {
    width: 121px;
    height: 113px;
  }

  .icon-symbol.-level2 {
    width: 121px;
    height: 216px;
  }

  .icon-symbol.-level3 {
    width: 121px;
    height: 317px;
  }

  .icon-symbol.-level4 {
    width: 121px;
    height: 419px;
  }
}

@media screen and (max-width: 840px) {
  .table-luckynangkwak {
    background-size: 699px 602px;
    width: 699px;
    height: 602px;
    transform: translate(0px, -57px);
  }

  .top-reel {
    width: 67%;
    transform: translate(113px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-116px, -5px);
  }

  .icon-symbol.-level1 {
    width: 115px;
    height: 108px;
  }

  .icon-symbol.-level2 {
    width: 115px;
    height: 208px;
  }

  .icon-symbol.-level3 {
    width: 115px;
    height: 305px;
  }

  .icon-symbol.-level4 {
    width: 116px;
    height: 403px;
  }
}

@media screen and (max-width: 800px) {
  .table-luckynangkwak {
    background-size: 659px 569px;
    width: 659px;
    height: 569px;
    transform: translate(0px, -56px);
  }

  .top-reel {
    width: 67%;
    transform: translate(111px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-111px, -6px);
  }

  .icon-symbol.-level1 {
    width: 110px;
    height: 105px;
  }

  .icon-symbol.-level2 {
    width: 111px;
    height: 197px;
  }

  .icon-symbol.-level3 {
    width: 111px;
    height: 289px;
  }

  .icon-symbol.-level4 {
    width: 111px;
    height: 383px;
  }
}

@media screen and (max-width: 780px) {
  .top-reel {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 67%;
    transform: translate(105px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-107px, 0px);
  }

  .icon-symbol.-level1 {
    width: 107px;
    height: 89px;
  }

  .icon-symbol.-level2 {
    width: 107px;
    height: 177px;
  }

  .icon-symbol.-level3 {
    width: 107px;
    height: 264px;
  }

  .icon-symbol.-level4 {
    width: 106px;
    height: 352px;
  }
}

@media screen and (max-width: 770px) {
  .heading-luckynangkwak {
    font-size: 18px;
  }

  .table-luckynangkwak {
    background-size: 638px 550px;
    width: 638px;
    height: 550px;
    margin-bottom: 1%;
    transform: translate(0px, -55px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-luckynangkwak {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-luckynangkwak {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 67%;
    transform: translate(104px, -6px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-107px, -5px);
  }

  .icon-symbol.-level1 {
    width: 107px;
    height: 100px;
  }

  .icon-symbol.-level2 {
    width: 107px;
    height: 190px;
  }

  .icon-symbol.-level3 {
    width: 107px;
    height: 279px;
  }

  .icon-symbol.-level4 {
    width: 106px;
    height: 369px;
  }

  .text-multiplier {
    width: 500px;
  }
}

@media screen and (max-width: 740px) {
  .heading-luckynangkwak {
    font-size: 18px;
  }

  .table-luckynangkwak {
    background-size: 614px 526px;
    width: 614px;
    height: 526px;
    margin-bottom: 1%;
    transform: translate(0px, -53px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-luckynangkwak {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-luckynangkwak {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(100px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-102px, -4px);
  }

  .icon-symbol.-level1 {
    width: 102px;
    height: 95px;
  }

  .icon-symbol.-level2 {
    width: 99px;
    height: 182px;
  }

  .icon-symbol.-level3 {
    width: 99px;
    height: 268px;
  }

  .icon-symbol.-level4 {
    width: 102px;
    height: 353px;
  }
}

@media screen and (max-width: 710px) {
  .heading-luckynangkwak {
    font-size: 18px;
  }

  .table-luckynangkwak {
    background-size: 582px 500px;
    width: 582px;
    height: 500px;
    margin-bottom: 1%;
    transform: translate(-2px, -54px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-luckynangkwak {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-luckynangkwak {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(95px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-97px, -4px);
  }

  .icon-symbol.-level1 {
    width: 96px;
    height: 92px;
  }

  .icon-symbol.-level2 {
    width: 95px;
    height: 171px;
  }

  .icon-symbol.-level3 {
    width: 95px;
    height: 253px;
  }

  .icon-symbol.-level4 {
    width: 97px;
    height: 335px;
  }
}

@media screen and (max-width: 680px) {
  .heading-luckynangkwak {
    font-size: 18px;
  }

  .table-luckynangkwak {
    background-size: 566px 482px;
    width: 566px;
    height: 482px;
    margin-bottom: 1%;
    transform: translate(-1px, -55px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-luckynangkwak {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-luckynangkwak {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(95px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-95px, -4px);
  }

  .icon-symbol.-level1 {
    width: 94px;
    height: 88px;
  }

  .icon-symbol.-level2 {
    width: 94px;
    height: 166px;
  }

  .icon-symbol.-level3 {
    width: 95px;
    height: 244px;
  }

  .icon-symbol.-level4 {
    width: 95px;
    height: 322px;
  }
}

@media screen and (max-width: 650px) {
  .heading-luckynangkwak {
    font-size: 18px;
  }

  .table-luckynangkwak {
    background-size: 543px 470px;
    width: 543px;
    height: 470px;
    margin-bottom: 1%;
    transform: translate(0px, -56px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-luckynangkwak {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-luckynangkwak {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(91px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-91px, -4px);
  }

  .icon-symbol.-level1 {
    width: 91px;
    height: 85px;
  }

  .icon-symbol.-level2 {
    width: 91px;
    height: 160px;
  }

  .icon-symbol.-level3 {
    width: 91px;
    height: 236px;
  }

  .icon-symbol.-level4 {
    width: 92px;
    height: 312px;
  }
}

@media screen and (max-width: 620px) {
  .heading-luckynangkwak {
    font-size: 18px;
  }

  .table-luckynangkwak {
    background-size: 516px 444px;
    width: 516px;
    height: 444px;
    margin-bottom: 1%;
    transform: translate(-2px, -53px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-luckynangkwak {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-luckynangkwak {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(87px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-86px, -4px);
  }

  .icon-symbol.-level1 {
    width: 86px;
    height: 80px;
  }

  .icon-symbol.-level2 {
    width: 86px;
    height: 153px;
  }

  .icon-symbol.-level3 {
    width: 86px;
    height: 225px;
  }

  .icon-symbol.-level4 {
    width: 86px;
    height: 298px;
  }
}

@media screen and (max-width: 600px) {
  .table-luckynangkwak {
    background-size: 498px 430px;
    width: 498px;
    height: 430px;
    transform: translate(0px, -54px);
  }

  .top-reel {
    width: 67%;
    transform: translate(82px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-83px, -4px);
  }

  .icon-symbol.-level1 {
    width: 83px;
    height: 79px;
  }

  .icon-symbol.-level2 {
    width: 83px;
    height: 148px;
  }

  .icon-symbol.-level3 {
    width: 83px;
    height: 219px;
  }

  .icon-symbol.-level4 {
    width: 83px;
    height: 288px;
  }
}

@media screen and (max-width: 570px) {
  .table-luckynangkwak {
    background-size: 474px 410px;
    width: 474px;
    height: 410px;
    transform: translate(0px, -53px);
  }

  .top-reel {
    width: 66%;
    transform: translate(80px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-80px, -4px);
  }

  .icon-symbol.-level1 {
    width: 79px;
    height: 75px;
  }

  .icon-symbol.-level2 {
    width: 83px;
    height: 142px;
  }

  .icon-symbol.-level3 {
    width: 83px;
    height: 207px;
  }

  .icon-symbol.-level4 {
    width: 79px;
    height: 274px;
  }
}

@media screen and (max-width: 540px) {
  .table-luckynangkwak {
    background-size: 450px 390px;
    width: 450px;
    height: 390px;
    transform: translate(-1px, -54px);
  }

  .top-reel {
    width: 66%;
    transform: translate(76px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-75px, -4px);
  }

  .icon-symbol.-level1 {
    width: 74px;
    height: 71px;
  }

  .icon-symbol.-level2 {
    width: 75px;
    height: 134px;
  }

  .icon-symbol.-level3 {
    width: 75px;
    height: 198px;
  }

  .icon-symbol.-level4 {
    width: 74px;
    height: 260px;
  }

  .text-multiplier {
    width: 500px;
  }
}

@media screen and (max-width: 510px) {
  .table-luckynangkwak {
    background-size: 425px 367px;
    width: 425px;
    height: 367px;
    transform: translate(0px, -54px);
  }

  .top-reel {
    width: 66%;
    transform: translate(68px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-71px, -3px);
  }

  .icon-symbol.-level1 {
    width: 70px;
    height: 66px;
  }

  .icon-symbol.-level2 {
    width: 71px;
    height: 126px;
  }

  .icon-symbol.-level3 {
    width: 71px;
    height: 185px;
  }

  .icon-symbol.-level4 {
    width: 71px;
    height: 244px;
  }
}


@media screen and (max-width: 480px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-luckynangkwak>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-luckynangkwak {
    font-size: 12px;
  }

  .table-luckynangkwak {
    background-size: 399px 344px;
    width: 399px;
    height: 344px;
    transform: translate(-1px, -53px);
  }

  .text-subhead-luckynangkwak {
    font-size: 14px;
  }

  .bet-box-luckynangkwak {
    min-width: 230px;
    max-width: auto;
    /* height: 200px; */
  }

  .bonus-box-luckynangkwak {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-luckynangkwak {
    width: 422px;
  }

  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-luckynangkwak {
    width: 50px;
    height: 50px;
  }

  .text-win {
    height: 60px;
  }

  .text-multiplier {
    width: 422px;
  }

  .icon-bonus-luckynangkwak {
    width: 60px;
    height: 60px;
  }

  .top-reel {
    width: 67%;
    transform: translate(66px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-67px, -3px);
  }

  .icon-symbol.-level1 {
    width: 67px;
    height: 61px;
  }

  .icon-symbol.-level2 {
    width: 67px;
    height: 119px;
  }

  .icon-symbol.-level3 {
    width: 67px;
    height: 174px;
  }

  .icon-symbol.-level4 {
    width: 67px;
    height: 229px;
  }
}

@media screen and (max-width: 450px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-luckynangkwak>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-luckynangkwak {
    font-size: 12px;
  }

  .table-luckynangkwak {
    background-size: 375px 324px;
    width: 375px;
    height: 324px;
    transform: translate(-1px, -53px);
  }

  .text-subhead-luckynangkwak {
    font-size: 14px;
  }

  .bet-box-luckynangkwak {
    min-width: 230px;
    max-width: auto;
    /* height: 200px; */
  }

  .bonus-box-luckynangkwak {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-luckynangkwak {
    width: 422px;
  }

  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-luckynangkwak {
    width: 50px;
    height: 50px;
  }

  .text-multiplier {
    width: 422px;
  }

  .icon-bonus-luckynangkwak {
    width: 60px;
    height: 60px;
  }

  .top-reel {
    width: 67%;
    transform: translate(61px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-62px, -3px);
  }

  .icon-symbol.-level1 {
    width: 62px;
    height: 59px;
  }

  .icon-symbol.-level2 {
    width: 62px;
    height: 111px;
  }

  .icon-symbol.-level3 {
    width: 62px;
    height: 163px;
  }

  .icon-symbol.-level4 {
    width: 62px;
    height: 215px;
  }
}

@media screen and (max-width: 420px) {

  .table-luckynangkwak {
    background-size: 350px 300px;
    width: 350px;
    height: 300px;
    transform: translate(1px, -52px);
  }

  .top-reel {
    width: 66%;
    transform: translate(59px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-58px, -2px);
  }

  .icon-symbol.-level1 {
    width: 58px;
    height: 55px;
  }

  .icon-symbol.-level2 {
    width: 58px;
    height: 103px;
  }

  .icon-symbol.-level3 {
    width: 58px;
    height: 151px;
  }

  .icon-symbol.-level4 {
    width: 58px;
    height: 200px;
  }
}

@media screen and (max-width: 390px) {

  .table-luckynangkwak {
    background-size: 325px 280px;
    width: 325px;
    height: 280px;
    transform: translate(0px, -53px);
  }

  .top-reel {
    width: 66%;
    transform: translate(55px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-54px, 0px);
  }

  .icon-symbol.-level1 {
    width: 54px;
    height: 44px;
  }

  .icon-symbol.-level2 {
    width: 54px;
    height: 86px;
  }

  .icon-symbol.-level3 {
    width: 54px;
    height: 134px;
  }

  .icon-symbol.-level4 {
    width: 54px;
    height: 179px;
  }
}

@media screen and (max-width: 360px) {

  .table-luckynangkwak {
    background-size: 300px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(51px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-50px, 0px);
  }

  .icon-symbol.-level1 {
    width: 50px;
    height: 42px;
  }

  .icon-symbol.-level2 {
    width: 50px;
    height: 82px;
  }

  .icon-symbol.-level3 {
    width: 50px;
    height: 123px;
  }

  .icon-symbol.-level4 {
    width: 50px;
    height: 165px;
  }
}

@media screen and (max-width: 340px) {

  .table-luckynangkwak {
    background-size: 279px 100px;
    width: 399px;
    height: 180px;
    transform: translate(2px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(48px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-47px, 0px);
  }

  .icon-symbol.-level1 {
    width: 47px;
    height: 38px;
  }

  .icon-symbol.-level2 {
    width: 47px;
    height: 77px;
  }

  .icon-symbol.-level3 {
    width: 47px;
    height: 115px;
  }

  .icon-symbol.-level4 {
    width: 47px;
    height: 154px;
  }
}

@media screen and (max-width: 320px) {

  .table-luckynangkwak {
    background-size: 259px 64px;
    width: 399px;
    height: 180px;
    transform: translate(4px, -76px);
  }

  .top-reel {
    width: 66%;
    transform: translate(44px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-44px, 0px);
  }

  .icon-symbol.-level1 {
    width: 44px;
    height: 36px;
  }

  .icon-symbol.-level2 {
    width: 44px;
    height: 71px;
  }

  .icon-symbol.-level3 {
    width: 44px;
    height: 107px;
  }

  .icon-symbol.-level4 {
    width: 44px;
    height: 143px;
  }
}

.multiplier-text {
  font-size: 9vw;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #FFF639;
  font-weight: 700;
  text-shadow: -1px -1px 0 #b33000,
    1px -1px 0 #b33000,
    -1px 1px 0 #b33000,
    1px 1px 0 #b33000;
}
</style>